import { DashboardFloatingAlertStore } from 'dashboard-components/js/shared/DashboardFloatingAlertStore.ts';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const handleErrorMessage = action => {
  DashboardFloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quickFilter.fetchFailed",
      options: {
        action
      }
    }),
    type: 'danger'
  });
};